import React from 'react';
import { motion } from 'framer-motion';
import profileImage from '../images/profile.jpeg'; // Replace with your image path

function About() {
  return (
    <section className="about">
      <motion.div
        className="about-content"
        initial={{ x: -200, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <div className="about-image">
          <img src={profileImage} alt="Vignesh M - Software Associate" />
        </div>
        <div className="about-text">
          <h2>About Me</h2>
          <a 
            href="https://www.hackerrank.com/profile/vigneshmunikann1" 
            target="_blank" 
            rel="noopener noreferrer"
            className="resume-button"
            aria-label="Download Resume from HackerRank"
          >
            📄 View Resume
          </a>
          <p>
            Hello! I'm Vignesh M, a dedicated <strong>Software Associate</strong> at <strong>Tribus Point</strong>, where I'm actively contributing to innovative software solutions. Currently based in Coimbatore, Tamil Nadu, I bring a strong foundation in full-stack development and a passion for creating scalable, real-world applications.
            <br /><br />
            I hold a B.Tech in Computer Science and Business Systems from Sri Eshwar College of Engineering with a CGPA of 8.28. My technical expertise spans across <strong>Node.js, React.js, FastAPI, Django, PostgreSQL, MongoDB, SQL, and Tailwind CSS</strong>. Throughout my journey, I've developed and deployed full-stack systems like the <strong>KSD Quail Management System</strong> and <strong>Live Polling Platform</strong>, solving complex domain-specific challenges with modern backend architectures and responsive frontends.
            <br /><br />
            My professional experience includes multiple internships across diverse domains, where I've contributed to team-based software projects and honed my skills in both frontend and backend development. I'm continuously learning and exploring emerging technologies including <strong>AI integration, automation pipelines, serverless functions</strong>, and cloud tools like <strong>Docker, AWS, and GitHub Actions</strong>.
            <br /><br />
            I believe in building efficient, accessible, and purpose-driven software that makes a real impact. When I'm not coding, I find inspiration through solo travel, mountain trekking, meditation, and quiet moments in nature — experiences that help me maintain a calm, focused, and creative mindset in my work.
          </p>
        </div>
      </motion.div>
    </section>
  );
}

export default About;
